import { render, staticRenderFns } from "./DetailGadaiKomp.vue?vue&type=template&id=1d4f67e6&"
import script from "./DetailGadaiKomp.vue?vue&type=script&lang=js&"
export * from "./DetailGadaiKomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports